<template lang="pug">
  .skeleton
    template(v-if="type == 'orders'")
      .skeleton__order(v-for="i in count")
        .skeleton__order_content
          .skeleton__order_content-picture
          .skeleton__order_content-description
            .skeleton__order_content-description--title
            .skeleton__order_content-description--descline
            .skeleton__order_content-description--descline
            .skeleton__order_content-description--descline
        .skeleton__order_status
          .skeleton__order_status--line
          .skeleton__order_status--line
          .skeleton__order_status--line
    template(v-if="type == 'transactions'")
      .skeleton__transactions
        .skeleton__transactions-item(v-for="i in count")
</template>

<script>
export default {
  props: ['type', 'count'],
};
</script>

<style lang="scss">
@keyframes pulse {
  0%{
    opacity: 1;
  }
  50%{
    opacity: .5;
  }
  100%{
    opacity: 1;
  }
}
.skeleton{
  animation: pulse 1s ease infinite;
  &__order{
    width: 100%;
    border-top: 1px solid #ddd;
    display: flex;
    &_content{
      width: 750px;
      display: flex;
      padding: 1.5rem 0;
      &-picture{
        width: 170px;
        height: 240px;
        min-width: 170px;
        background: #ddd;
      }
      &-description{
        width: 100%;
        padding: .5rem 1.5rem;
        &--title{
          height: 16px;
          width: 100%;
          border-radius: 1rem;
          background: #ddd;
          margin-bottom: 1rem;
        }
        &--descline{
          height: 12px;
          width: 50%;
          border-radius: 1rem;
          background: #ddd;
          margin-bottom: .75rem;
        }
      }
    }
    &_status{
      width: 100%;
      border-left: 1px solid #ddd;
      padding: 40px 35px;
      max-width: 250px;
      &--line{
        height: 12px;
        width: 100%;
        border-radius: 1rem;
        background: #ddd;
        margin-bottom: .75rem;
      }
    }
  }
  &__transactions {
    &-item {
      border-radius: .5rem;
      height: 25px;
      width: 100%;
      &:nth-child(even) {
        background: #ddd;
      }
    }
  }
}
</style>
